import React, { useContext, useEffect, useState, useRef } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { WsEvents, useWebsocket } from "../../context/hooks/WebSocket";
import { Select, MenuItem } from "@mui/material";
import Context from "../../context/Context";
import CardMolds from "./CardMolds";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
// import { Impressao } from "./template/Impressao";
import { Impressao } from "./template/RelatorioPecasMoldes";
import { ImpressaoEtiqueta } from "./template/ImpressaoEtiqueta";
import { TextField } from "@mui/material";
import toast from "react-hot-toast";
import blogFetch from "../../axios/config";
import SimpleModal from "../../components/SimpleModal";
import Pendency from "./components/Pendency";
import Loading from "../../components/Loading";
import language from "../../nls/language.json";
import "./Molds.css";
import { getTimeFromDateTimeLocate } from "../../utils/DataUtils";
import { handleSortByValue } from "../../utils/sort";
import { Col, Container, Row } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Badge from "react-bootstrap/Badge";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const INITIAL_MODAL = {
  isShow: false,
  title: "",
  body: "",
};

const Molds = () => {
  const [inputMold, setInputMold] = useState("");
  const [showModal, setShowModal] = useState(INITIAL_MODAL);
  const [statusFurnace, setStatusFurnace] = useState([]);
  const [selectedFurnace, setSelectedFurnace] = useState("");

  const [showMoldChangeModal, setShowMoldChangeModal] = useState(false);
  const [changeMoldData, setChangeMoldData] = useState([]);

  const [newVagaoKey, setNewVagaoKey] = useState();
  const [newSerial, setNewSerial] = useState();
  const [newchangeMoldLote, setnewchangeMoldLote] = useState();
  const [newchangeMold, setNewChangeMold] = useState();

  const [mold, setMold] = useState();

  const {
    moldsSector,
    setMoldsSector,
    getMolds,
    getChangeMolds,
    putMold,
    loadingFullScreen,
    setLoadingFullScreen,
    selectedCountry,
    furnace,
    getFurnace,
    getHourByFurnace,
    loading,
    setLoading,
    setOpenModal,
    openModal,
    modelModal,
  } = useContext(Context);

  const ws = useWebsocket();

  const textFieldRef = useRef(null);

  useEffect(() => {
    refreshStats();
    getFurnace();

    ws.setHandler(WsEvents.NewWagon, "NewWagon-Wagon", refreshStats);
    ws.setHandler(WsEvents.UpdateWagon, "UpdateWagon-Wagon", refreshStats);
  }, []);

  // Auto-refresh com guardrail de inatividade.
  // Não atualiza enquanto o usuário está mexendo, com modal aberto,
  // digitando no scanner, ou com a aba em segundo plano.
  const REFRESH_INTERVAL_MS = 30_000;
  const ACTIVITY_GRACE_MS = 5_000;
  const busyRef = useRef(false);

  useEffect(() => {
    busyRef.current = !!(
      showModal.isShow ||
      showMoldChangeModal ||
      openModal ||
      inputMold
    );
  }, [showModal, showMoldChangeModal, openModal, inputMold]);

  useEffect(() => {
    let lastActivity = Date.now();
    const onActivity = () => { lastActivity = Date.now(); };
    window.addEventListener("keydown", onActivity);
    window.addEventListener("mousedown", onActivity);

    const id = setInterval(() => {
      const visible = document.visibilityState === "visible";
      const idleEnough = Date.now() - lastActivity >= ACTIVITY_GRACE_MS;
      const inputFocused =
        textFieldRef.current?.querySelector?.("input") === document.activeElement;

      if (visible && idleEnough && !busyRef.current && !inputFocused) {
        refreshStats();
      }
    }, REFRESH_INTERVAL_MS);

    return () => {
      clearInterval(id);
      window.removeEventListener("keydown", onActivity);
      window.removeEventListener("mousedown", onActivity);
    };
  }, []);

  useEffect(() => {
    setShowModal(INITIAL_MODAL);
  }, [moldsSector]);

  useEffect(() => {
    if (furnace.length) {
      getHourFurnace(furnace);
    }
  }, [furnace]);

  const handleSelectFurnace = (event) => {
    setSelectedFurnace(event.target.value || "");
  };
  const refreshStats = async () => {
    const response = await getMolds();
    setMoldsSector(response);
  };

  const getChangeMoldsByMoldeKey = async (MoldeKey) => {
    const response = await getChangeMolds(MoldeKey);
    setChangeMoldData((m) => response);
  };

  const getHourFurnace = async (furnace) => {
    const response = await getHourByFurnace(furnace, 'AGUARDANDO MOLDE');
    setStatusFurnace(response);
  };

  const handlePrint = async (dataOpen) => {
    const classeImpressao = new Impressao(dataOpen);
    const documento = await classeImpressao.PreparaDocumento();
    pdfMake.createPdf(documento).open({}, window.open("", "_blank"));
  };

  const handlePrintLabel = async (dataOpen) => {
    const classeImpressao = new ImpressaoEtiqueta(dataOpen);
    const documento = await classeImpressao.PreparaDocumento();
    pdfMake.createPdf(documento).print({}, window.frames["printPdf"]);
  };

  const handleInputMold = ({ target }) => {
    const { value } = target;
    setInputMold(value);
  };

  const handleKeyDown = async (e) => {
    if (e.key === "Enter" || e.key === "Tab" || e.key === "NumpadEnter") {
      const barCode = inputMold.split(".");
      if (barCode.length !== 3)
        return toast.error(
          language[selectedCountry.name].Moldes.notification.errorBarCode,
          {
            duration: 4000,
          }
        );

      const [wagonKey, moldKey, ordemSerial] = barCode;
      try {
        setLoading(true);
        await putMold({
          vagao_Key: wagonKey,
          molde_Key: moldKey,
          ordem_Serial: ordemSerial,
          status: "RESERVADO",
        });
        setInputMold("");
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleModal = (data, title) => {
    setShowModal({
      isShow: true,
      body: bodyEditPendencias(data),
      title: title,
    });
  };

  const handleMoldCanceled = async (data) => {
    await putMold({
      vagao_Key: data.vagaoKey,
      molde_Key: data.moldKey,
      ordem_Serial: data.ordemSerial,
      status: "ESTOQUE",
    });
  };

  const handleMoldChange = async (data) => {
    setNewSerial();
    setNewVagaoKey();
    setNewChangeMold();
    setnewchangeMoldLote("");
    setNewSerial((s) => data.ordemSerial);
    setNewVagaoKey((v) => data.vagaoKey);

    getChangeMoldsByMoldeKey(data.moldKey);
    setShowMoldChangeModal(true);
  };

  const handleConfirmMold = async (data) => {
    try {
      setShowMoldChangeModal(false);
      await putMold({
        vagao_Key: data.vagaoKey,
        molde_Key: data.moldKey,
        ordem_Serial: data.ordemSerial,
        status: "RESERVADO",
        qtd_Passagem: data.qtd_Passagem,
        qtd_PassagemMax: data.qtd_PassagemMax,
        molde_Lote: data.molde_Lote,
        molde_Codigo: data.molde_Codigo,
        molde_Descricao: data.molde_Descricao,
        molde_Estoque: data.molde_Estoque,
      });

      setInputMold("");
      setnewchangeMoldLote("");
      setNewChangeMold();
      setChangeMoldData([]);
    } catch (error) {
      console.log(error);
    }
  };

  const saveMoldChange = async (wagonKey, moldKey, ordemSerial) => {
    try {
      setLoading(true);
      setShowMoldChangeModal(false);
      await putMold({
        vagao_Key: wagonKey,
        molde_Key: moldKey,
        ordem_Serial: ordemSerial,
        status: "RESERVADO",
      });
      setInputMold("");
      setnewchangeMoldLote("");
      setNewChangeMold();
      setChangeMoldData([]);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdataWagon = (data, status) => {
    const formData = new FormData();

    formData.append("Vagao_Key", data.wagon.vagao_Key);
    formData.append("Status", status);
    formData.append("Status_Peca", status);

    putWagon(formData);
  };

  const bodyEditPendencias = (data) => {
    return <Pendency data={data} />;
  };

  const putWagon = async (params) => {
    try {
      setLoading(true);
      await blogFetch.put(`/ISAGA_VagoesFornos/status`, params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const response = await getMolds();
      setMoldsSector(response);

      toast.success(
        language[selectedCountry.name].Moldes.notification.successUpdate,
        {
          duration: 4000,
        }
      );
    } catch (error) {
      console.error(error);
      toast.error(
        language[selectedCountry.name].Moldes.notification.errorUpdate,
        {
          duration: 4000,
        }
      );
    } finally {
      setLoading(false);
    }
  };

  //c0onsole.log("Mode_Modal:" + modelModal.vagao_Key);

  const nextTime = (time) => {
    if (!time) return "";
    const newDate = new Date(time);
    return getTimeFromDateTimeLocate(
      newDate.toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })
    );
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  

  const handleListMolds = (furnaces, molds) => {
    if (!Array.isArray(furnaces)) return [];
    const arrCard = furnaces.reduce((acc, curr, index) => {
      const arrMoldByFurnace = molds.filter(
        (mold) =>
          mold.typesPiecesCombinations.forno === curr.forno &&
          mold.moldsWagon.length > 0
      );


      if (arrMoldByFurnace.length) {
        const queue = Array.isArray(curr.data?.data) ? curr.data.data : [];
        const fornoEtapa = queue[0]?.fornoEtapa ?? null;

        const uniqueWagonKeys = [];
        arrMoldByFurnace.forEach((m) => {
          if (!uniqueWagonKeys.includes(m.wagon.vagao_Key)) {
            uniqueWagonKeys.push(m.wagon.vagao_Key);
          }
        });

        arrMoldByFurnace.forEach((wagon, i) => {
          const wagonIdx = uniqueWagonKeys.indexOf(wagon.wagon.vagao_Key);
          const dateTime = queue[wagonIdx]?.dateTime ?? null;

          acc.push({
            dateTime: nextTime(dateTime, i, fornoEtapa),
            component: (
              <Col lg={6}>
                <CardMolds
                  key={`card-${wagon.wagon.vagao_Serial}-${i}`}
                  data={wagon}
                  handlePrint={handlePrint}
                  handlePrintLabel={handlePrintLabel}
                  handleBlock={handleModal}
                  handleUpdataWagon={handleUpdataWagon}
                  handleMoldCanceled={handleMoldCanceled}
                  handleMoldChange={handleMoldChange}
                  handleConfirmMold={handleConfirmMold}
                  furnaceEntryForecast={nextTime(dateTime, i, fornoEtapa)}
                />
              </Col>
            ),
          });
        });
      }
      return acc;
    }, []);

    return handleSortByValue(arrCard, "dateTime", 1);
  };

  const filteredCards = handleListMolds(statusFurnace, moldsSector).filter(
    (card) => {
      const children =
        card?.component?.props?.children?.props?.data?.typesPiecesCombinations
          ?.forno || "";
      return children.includes(selectedFurnace);
    }
  );

  return (
    <>
      <Navbar />

      <Sidebar />

      <Container className={`app_body`} fluid>
        {!loading ? (
          <>
            {!!moldsSector && moldsSector.length ? (
              <Row>
                <iframe id="printPdf" name="printPdf" />
                <SimpleModal
                  isShow={showModal.isShow}
                  title={showModal.title}
                  body={showModal.body}
                  INITIAL_MODAL={INITIAL_MODAL}
                  setShowModal={setShowModal}
                />
                <div className="d-flex align-items-center mb-3">
                  <TextField
                    className="p-2 me-2 flex-grow-1"
                    label="Leitor"
                    value={inputMold}
                    autoComplete="off"
                    onChange={handleInputMold}
                    onKeyDown={handleKeyDown}
                    onFocus={() => setInputMold("")}
                    inputRef={textFieldRef}
                    autoFocus
                    style={{ maxWidth: "80%" }}
                  />

                  <Select
                    value={selectedFurnace}
                    onChange={handleSelectFurnace}
                    displayEmpty
                    className="flex-shrink-1"
                    style={{ minWidth: "20%" }}
                  >
                    <MenuItem value="">
                      <em>Todos os Fornos</em>
                    </MenuItem>
                    {furnace.map((furnaceItem) => (
                      <MenuItem
                        key={furnaceItem.forno_Name}
                        value={furnaceItem.forno_Name}
                      >
                        {furnaceItem.forno_Name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                {filteredCards.map((card, i) => card.component)}
              </Row>
            ) : (
              <div>{language[selectedCountry.name].Moldes.semMolde}</div>
            )}
          </>
        ) : (
          <Loading />
        )}
      </Container>

      <Modal
        show={showMoldChangeModal}
        onHide={() => {
          setShowMoldChangeModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Mudar Molde Selecionado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="d-flex justify-content-center">
              <Dropdown
                className="w-full"
                onSelect={(eventKey) => {
                  const { molde_Key, molde_Lote } = JSON.parse(eventKey);
                  setNewChangeMold(molde_Key);
                  setnewchangeMoldLote(molde_Lote);
                }}
              >
                <Dropdown.Toggle style={{ width: "300px" }}>
                  {newchangeMoldLote ? newchangeMoldLote : "Selecione um molde"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {changeMoldData.map((mold) => (
                    <Dropdown.Item
                      key={mold.molde_Lote}
                      eventKey={JSON.stringify({
                        molde_Key: mold.molde_Key,
                        molde_Lote: mold.molde_Lote,
                      })}
                      disabled={
                        mold.molde_Status === "MANUTENCAO" ||
                        mold.molde_Status === "RESERVADO"
                      }
                    >
                      {mold.molde_Lote} - {mold.molde_SAPLocal}
                      <Badge
                        bg={
                          mold.molde_Status === "CURVANDO" ||
                          mold.molde_Status === "MANUTENCAO"
                            ? "danger"
                            : mold.molde_Status === "RESERVADO"
                            ? "warning"
                            : "success"
                        }
                      >
                        {mold.molde_Status}
                      </Badge>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              if (newchangeMold && newchangeMold !== -1) {
                saveMoldChange(newVagaoKey, newchangeMold, newSerial);
              } else {
                toast.error("Selecione um molde para trocar!");
              }
            }}
            variant="success"
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openModal} centered>
        {/* Substituí Modal.Header por um <div> para evitar conflitos de estilização */}
        <div className="flex flex-col items-center p-4 bg-white">
          <p className="text-red-600 font-extrabold text-2xl w-full text-center flex justify-center">
            Última passagem do molde:{" "}
            <span className="font-extrabold text-red-700">
              {modelModal?.molde_Lote}
            </span>
          </p>
        </div>

        <Modal.Body className="text-gray-800 text-lg">
          <div className="bg-gray-50 p-5 rounded-lg shadow-md border border-gray-300">
            <div className="flex justify-between border-b border-gray-300 py-3">
              <span className="font-semibold text-gray-700 text-lg">
                Código:
              </span>
              <span className="text-gray-900 font-bold text-lg">
                {modelModal?.molde_Codigo}
              </span>
            </div>
            <div className="flex justify-between border-b border-gray-300 py-3">
              <span className="font-semibold text-gray-700 text-lg">
                Descrição:
              </span>
              <span className="text-gray-900 font-bold text-lg">
                {modelModal?.molde_Descricao}
              </span>
            </div>
            <div className="flex justify-between pt-3">
              <span className="font-semibold text-gray-700 text-lg">
                Estoque:
              </span>
              <span className="text-gray-900 font-bold text-lg">
                {modelModal?.molde_Estoque}
              </span>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="w-full bg-red-600 hover:bg-red-700 text-white font-bold text-lg py-3 rounded-lg transition duration-300 shadow-md"
            onClick={() => {
              if (modelModal?.molde_Codigo) {
                const link = document.createElement('a');
                link.href = `sagaprintserver:BR_Molde;SAGA_User;${modelModal.molde_Codigo}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
              closeModal();
            }}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Molds;
